/**
 * מזהה את מזהה השיחה (טלפון וכו') מנתיב /chats/... — לשימוש עם route אחד `/chats/*` בלי תלות ב-useParams.
 */
export function parseChatUserIdFromPathname(pathname: string): string | undefined {
  const p = pathname.replace(/\/$/, '') || '';
  const custom = p.match(/^\/chats\/custom\/[^/]+\/([^/]+)$/);
  if (custom) return custom[1];
  const snoozed = p.match(/^\/chats\/my\/snoozed\/([^/]+)$/);
  if (snoozed) return snoozed[1];
  const sub = p.match(/^\/chats\/(?:my|not-my|unassigned|bots|completed)\/([^/]+)$/);
  if (sub) return sub[1];
  const rootChat = p.match(/^\/chats\/([^/]+)$/);
  if (rootChat) {
    const seg = rootChat[1];
    if (['my', 'not-my', 'unassigned', 'bots', 'completed', 'custom'].includes(seg)) return undefined;
    return seg;
  }
  return undefined;
}

/** מזהה viewId מתצוגה מותאמת: /chats/custom/:viewId/... */
export function parseCustomChatViewIdFromPathname(pathname: string): string | undefined {
  const m = pathname.match(/^\/chats\/custom\/([^/]+)/);
  return m ? m[1] : undefined;
}
